import { FiSearch } from "react-icons/fi";
import { useTranslator } from "@eo-locale/react";

import { Box } from "@/storybook-components";

import { useAppSelector } from "@/redux/store/hooks";

const SearchBar = () => {
  const { translate } = useTranslator();
  const { homePageRevision } = useAppSelector(
    (state) => state.homePageRevision
  );
  const backgroundColor =
    homePageRevision?.sections?.sections[0].theme.mainNavbarBackgroundColor;
  const textColor =
    homePageRevision?.sections?.sections[0].theme.mainNavbarTextColor;
  const { nonce } = useAppSelector((state) => state.adapter.adapter);

  return (
    <Box className="search-bar" role="search" backgroundColor={backgroundColor}>
      <form action="/search" acceptCharset="UTF-8" method="get">
        <div className="search-bar__container">
          <span className="icon">
            <FiSearch />
          </span>
          <input
            className="search-bar__input"
            aria-label={translate("participantHeader.search")}
            placeholder={translate("participantHeader.search")}
            style={{ border: `1px solid ${textColor}`, backgroundColor }}
            name="query"
            type="search"
            defaultValue=""
            data-testid="participant-header-search-input"
          />
        </div>
      </form>
      <style nonce={nonce}>
        {`
            .search-bar__input::placeholder {
              color: ${textColor} !important;
              opacity: 1;
            }
            .search-bar__input:-ms-input-placeholder {
              color: ${textColor} !important;
            }
            .search-bar__input::-ms-input-placeholder {
              color: ${textColor} !important;
            }
          `}
      </style>
    </Box>
  );
};

export default SearchBar;
